import TierHelper from '@/utils/lineitem-tier-helper'
import {EventBus} from '@/utils/event-bus'

export default {
  computed: {
    cartNote(){
      if(this.$store.getters.hasTrialPeriod){
        return this.t('cart.note.plan.trial', this.$store.getters.plan_placeholder);
      }
      return this.t('cart.note.plan.no_trial', this.$store.getters.plan_placeholder);
    },
    isSingleItem() {
      return this.$store.getters.order_cart_items.length == 1;
    }
  },
	methods: {
    removeDiscount(couponId) {
      this.$store.dispatch('remove_coupon', {id: couponId}).then((success, error) => {
        if (success) {
          EventBus.$emit('hp_log', {action:'coupon_removed'});
          if(this.$store.getters.is_checkout_new){
              this.$store.dispatch('determine_steps');
          }
        }
      }).catch(error => {
        logger.e(error);
      });
    },
    hasTieredPricing() {
      return TierHelper.hasTieredPricing(this.$store.getters.order_cart_items);
    }
  }
}